import React, { useEffect, useRef } from 'react'
import { useEditorStore } from '../store.js'

export function InteractiveCanvas() {
  const containerRef = useRef<HTMLDivElement>(null)
  const { markup, zoom } = useEditorStore(state => ({ markup: state.markup, zoom: state.zoom }))

  useEffect(() => {
    if (!containerRef.current || !markup) return

    // Render the Web Components directly
    containerRef.current.innerHTML = markup
  }, [markup])

  if (!markup) {
    return (
      <div id="wireframelm-canvas-root" className="interactive-canvas interactive-canvas__empty">
        Markup preview not available yet.
      </div>
    )
  }

  return (
    <div
      ref={containerRef}
      id="wireframelm-canvas-root"
      className="interactive-canvas"
      style={{
        transform: `scale(${zoom / 100})`,
        transformOrigin: 'top left',
        width: `${100 / (zoom / 100)}%`,
        height: `${100 / (zoom / 100)}%`
      }}
    />
  )
}
